import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import store from './store'; //

Vue.use(Router);

export const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/run_stop_chart",
      name: "Runstopchart",
      // lazy-loaded
      component: () => import("./views/run_stop_chart.vue")
    },
    //

    {
      path: "/run_stop_chartbyrunid",
      name: "Runstopchartbyrunid",
      // lazy-loaded
      component: () => import("./views/run_stop_chartbyrunid.vue")
    },

  {
      path: "/ai",
      name: "ai",
      // lazy-loaded
      component: () => import("./views/ai.vue")
    },
    //
    {
      path: "/stoppages_chart",
      name: "Stoppageschart",
      // lazy-loaded
      component: () => import("./views/stoppages_chart.vue")
    },
//

{
  path: "/p_inmonth",
  name: "pinmonth",
  // lazy-loaded
  component: () => import("./views/p_inmonth.vue")
},
{
  path: "/stoppages_most",
  name: "moststoppages",
  // lazy-loaded
  component: () => import("./views/stoppages_most.vue")
},

//

    {
      path: "/",
      name: "home",
      component: Home
    },

    {
      path: "/home",
      component: Home
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/register",
      component: Register
    },
    //
{
  path: "/dayreport",
  name: "Dayreport",
  // lazy-loaded
  component: () => import("./views/dayreport.vue")
},
{
  path: "/messedit",
  name: "messedit",
  // lazy-loaded
  component: () => import("./views/Messedit.vue")
},
{
  path: "/messedit2",
  name: "messedit2",
  // lazy-loaded
  component: () => import("./views/Messedit2.vue")
},
{
  path: "/stoppages_cat",
  name: "Stoppages_cat",
  // lazy-loaded
  component: () => import("./views/stoppages_chart2.vue")
},
{
  path: "/stoppagespermonth",
  name: "Stoppagespermonth",
  // lazy-loaded
  component: () => import("./views/stoppages_chart3.vue")
},
    {
      path: "/batch",
      name: "batch",
      component: () => {
        if (store.state.terminal==2) {
          return import("./views/Batch.vue"); //
        } else {
          return import("./views/Batch33.vue"); //
        }
      }
    }

    ,
    //
    {
      path: "/profile",
      name: "profile",
      // lazy-loaded
      component: () => import("./views/Home.vue")
    },
    {
      path: "/admin",
      name: "admin",
      // lazy-loaded
      component: () => import("./views/BoardAdmin.vue")
    },
    {
      path: "/mod",
      name: "moderator",
      // lazy-loaded
      component: () => import("./views/BoardModerator.vue")
    },
    {
      path: "/messages",
      name: "messages",
      // lazy-loaded
      component: () => import("./views/Opmessages.vue")
    },
    {
      path: "/messages2",
      name: "messages2",
      // lazy-loaded
      component: () => import("./views/Opmessages2.vue")
    },
    //
    {
      path: "/product",
      name: "product",
      // lazy-loaded
      component: () => import("./views/product.vue")
    },
    {
      path: "/target",
      name: "target",
      component: () => import("./views/target.vue")
    },
    {
      path: "/users",
      name: "users",
      component: () => import("./views/users.vue")
    },
    {
      path: "/cats",
      name: "cats",
      // lazy-loaded
      component: () => import("./views/Cats.vue")
    },
    {
      path: "/subcats",
      name: "subcats",
      // lazy-loaded
      component: () => import("./views/Subcats.vue")
    },
    {
      path: "/failures",
      name: "failures",
      // lazy-loaded
      component: () => import("./views/Failures.vue")
    },
    {
      path: "/chart",
      name: "chart",
      component: () => import("./views/Chartm.vue")
    },
    {
      path: "/chart2",
      name: "chart2",
      component: () => import("./views/Chartm2.vue")
    },
    // {
    //   path: "/chart20",
    //   name: "chart20",
    //   component: () => import("192.168.1.8:81/chart3")
    // },

    {
      path: "/chart3",
      name: "chart3",
      component: () => import("./views/Chartm3.vue")
    },
    {
      path: "/chart3monthly",
      name: "chart3monthly",
      component: () => import("./views/Chartm3monthly.vue")
    },
    //
    {
      path: "/ppd",
      name: "ppd",
      component: () => import("./views/Ppd.vue")
    },

    ///
    {
      path: "/maintmessages",
      name: "maintmessages",
      // lazy-loaded
      component: () => import("./views/Maintmessages.vue")
    },
    {
      path: "/managermessages",
      name: "managermessages",
      // lazy-loaded
      component: () => import("./views/Managermessages.vue")
    },
    {
      path: "/managermessages-manual",
      name: "managermessages-manual",
      // lazy-loaded
      component: () => import("./views/Managermessages-manual.vue")
    },
    {
      path: "/managermessages-tot",
      name: "managermessages-tot",
      // lazy-loaded
      component: () => import("./views/Managermessages-tot.vue")
    },
    {
      path: "/managermessages-rates",
      name: "managermessages-rates",
      // lazy-loaded
      component: () => import("./views/Managermessages-rates.vue")
    },
    ////////////////////////////////
    {
      path: "/assets",
      name: "assets",
      // lazy-loaded
      component: () => import("./views/Assets.vue")
    },
    {
      path: "/sites",
      name: "sites",
      // lazy-loaded
      component: () => import("./views/Sites.vue")
    },
    {
      path: "/departments",
      name: "departments",
      // lazy-loaded
      component: () => import("./views/Departments.vue")
    },
    {
      path: "/safety",
      name: "safety",
      // lazy-loaded
      component: () => import("./views/Safety.vue")
    },
    {
      path: "/safetyinstructions",
      name: "safetyinstructions",
      // lazy-loaded
      component: () => import("./views/SafetyInstructions.vue")
    },
    {
      path: "/failiurecodes",
      name: "failiurecodes",
      // lazy-loaded
      component: () => import("./views/FailiureCodes.vue")
    },
    {
      path: "/suppliers",
      name: "suppliers",
      // lazy-loaded
      component: () => import("./views/Suppliers.vue")
    },
    {
      path: "/emp",
      name: "employees",
      // lazy-loaded
      component: () => import("./views/Employees.vue")
    },
    {
      path: "/locations",
      name: "locations",
      // lazy-loaded
      component: () => import("./views/Locations.vue")
    },
    {
      path: "/mes2",
      name: "mes2",
      // lazy-loaded
      component: () => import("./views/Mes2.vue")
    },
    {
      path: "/user",
      name: "user",
      // lazy-loaded
      component: () => import("./views/BoardUser.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/login", "/register", "/home"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next("/login");
  } else {
    next();
  }
});
